module.exports = __webpack_public_path__ + "static/hacker-0671d0d38aec6eea252ac0ae12dedadb.svg";